// frontend/components/AddProject.js
import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ClipboardList, Plus } from "lucide-react";
import "./Project.css"; // ✅ create styling similar to Company.css

// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const AddProject = () => {
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    title: "",
    description: "",
    start_date: "",
    end_date: "",
    contact_person: "",
    contact_phone: "",
    location: "",
    image: null,
  });

  const [focusedFields, setFocusedFields] = useState({});
  const navigate = useNavigate();

  const handleFocus = (field) => {
    setFocusedFields((prev) => ({ ...prev, [field]: true }));
  };

  const handleBlur = (field) => {
    setFocusedFields((prev) => ({
      ...prev,
      [field]: !!data[field], // true if field has value
    }));
  };

  const onChangeHandler = (event) => {
    const { name, value, files } = event.target;
    if (files) {
      setData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!data.title.trim() || !data.start_date.trim()) {
      toast.error("Project title and start date are required");
      return;
    }

    try {
      setSubmitting(true);

      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        if (data[key] !== null && data[key] !== "") {
          formData.append(key, data[key]);
        }
      });

      const response = await axios.post(`${url}/api/projects`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        toast.success("Project added successfully!");
        setData({
          title: "",
          description: "",
          start_date: "",
          end_date: "",
          contact_person: "",
          contact_phone: "",
          location: "",
          image: null,
        });
        navigate("/ViewProjects");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to add project";
      toast.error(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-wrapper">
      <div className="project-form-container">
        <h2 className="form-title">
          <ClipboardList size={20} className="inline mr-2" /> Add New Project
        </h2>

        <div className="header">
          <button onClick={() => navigate("/ViewProjects")} className="add-button">
            <Plus size={16} /> View Projects
          </button>
        </div>

        <form
          className="project-form"
          onSubmit={onSubmitHandler}
          encType="multipart/form-data"
        >
          {[
            "title",
            "description",
            "start_date",
            "end_date",
            "contact_person",
            "contact_phone",
            "location",
          ].map((field) => (
            <div
              key={field}
              className={`form-field ${
                focusedFields[field] || data[field] ? "filled" : ""
              }`}
            >
              <input
                type={field.includes("date") ? "date" : "text"}
                name={field}
                value={data[field]}
                onChange={onChangeHandler}
                onFocus={() => handleFocus(field)}
                onBlur={() => handleBlur(field)}
                required={field === "title" || field === "start_date"}
              />
              <label>
                {field
                  .replace("_", " ")
                  .replace(/\b\w/g, (l) => l.toUpperCase())}
              </label>
            </div>
          ))}

          <div className="form-field file-input">
            <label>Project Image</label>
            <input
              type="file"
              name="image"
              accept="image/*"
              onChange={onChangeHandler}
            />
          </div>

          <button type="submit" className="submit-btn" disabled={submitting}>
            {submitting ? "Processing..." : "Add Project"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddProject;
